__webpack_require__.p = "//static.nbd.com.cn/corp/20220622brand-value/dist/";